"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _throttleDebounce = require("throttle-debounce");
var _cache = _interopRequireDefault(require("./utils/cache"));
var _dom = require("./utils/dom");
var _resizeSpy = _interopRequireDefault(require("./utils/resizeSpy"));
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var isSSR = typeof window === 'undefined';
var __DEV__ = process.env.NODE_ENV && process.env.NODE_ENV === "development";
var Store = /*#__PURE__*/ function() {
    "use strict";
    function Store(items, config) {
        var _this = this;
        _classCallCheck(this, Store);
        this._locks = 0;
        this.isMounted = false;
        this.renderDataCache = '';
        this.renderData = {
            spaceBefore: 0,
            sumItemSize: 0,
            items: [],
            indexesInViewport: []
        };
        this._onEndReachedRunning = false;
        this.disposers = [];
        this.initalNumToRender = 0;
        this.scroller = {
            el: undefined,
            height: 0,
            width: 0,
            scrollTop: 0,
            scrollLeft: 0,
            scrollWidth: 0,
            scrollHeight: 0
        };
        this.root = {
            el: undefined,
            width: 0,
            height: 0,
            before: 0
        };
        this.renderInitialItems = true;
        this.lockBetweenScrollPos = {
            start: 0,
            end: 0
        };
        this.items = items;
        this.config = config;
        this.onScroll = (0, _throttleDebounce).throttle(32, this.onScroll.bind(this));
        this.onResize = (0, _throttleDebounce).throttle(32, this.onResize.bind(this));
        this.calculateVisibleItems = (0, _throttleDebounce).throttle(25, this.calculateVisibleItems.bind(this));
        this.itemLayoutCache = _cache.default.getInstance(this.config.name, function(layout) {
            if (!_instanceof(layout, Promise)) // Geen promise, dan willen we de waarden normaliseren
            return _this.normalizeLayout(layout);
            return layout;
        });
    }
    var _proto = Store.prototype;
    _proto.mount = function mount(scrollerNode, root) {
        this.scroller.el = scrollerNode;
        this.scroller.el.addEventListener('scroll', this.onScroll, {
            passive: true
        });
        this.root.el = root;
        if (!isSSR) {
            var _this = this;
            if (__DEV__ && this.root.el.parentNode) {
                var computedStyles = window.getComputedStyle(this.root.el.parentNode);
                if (computedStyles.getPropertyValue('position') === 'static') console.warn("LazyList mag niet in een parent zitten met position static.", this.root.el.parentNode);
            }
            this.disposers.push(_resizeSpy.default.watch(this.scroller.el, function(size) {
                if (_this.scroller.width === size.width && _this.scroller.height === size.height) return;
                _this.scroller.width = size.width;
                _this.scroller.height = size.height;
                _this.onResize();
            }, {
                immediate: true
            }));
            this.disposers.push(_resizeSpy.default.watch(this.root.el, function(size) {
                if (_this.root.width === size.width && _this.root.height === size.height) return;
                _this.root.width = size.width;
                _this.root.height = size.height;
                _this.onResize();
            }, {
                immediate: true
            }));
        }
        this.isMounted = true;
    };
    _proto.unmount = function unmount() {
        var ref;
        (ref = this.scroller.el) === null || ref === void 0 ? void 0 : ref.removeEventListener('scroll', this.onScroll);
        this.disposers.forEach(function(dispose) {
            return dispose();
        });
        this.disposers = [];
        this.isMounted = false;
        this._onEndReachedRunning = false;
        this.lockBetweenScrollPos = {
            start: 0,
            end: 0
        };
    };
    _proto.checkRootOffset = function checkRootOffset() {
        if (!this.root.el || !this.scroller.el) return;
        // Vangt cases af waarbij er voor de lazylist ook nog andere elementen staan
        // die de positie van de lazylist binnen de scroller beinvloeden
        var rootOffset = (0, _dom).getDocumentOffsetPosition(this.root.el);
        var scrollerOffset = (0, _dom).getDocumentOffsetPosition(this.scroller.el);
        var top = rootOffset.top - scrollerOffset.top;
        var left = rootOffset.left - scrollerOffset.left;
        this.root.before = this.isVertical ? top : left;
    };
    // Events
    _proto.onScroll = function onScroll() {
        if (!this.scroller.el) return;
        var oldScroller = {
            scrollLeft: this.scroller.scrollLeft,
            scrollTop: this.scroller.scrollTop
        };
        var scrollTop = (0, _dom).getScrollTop(this.scroller.el);
        var scrollLeft = (0, _dom).getScrollLeft(this.scroller.el);
        this.scroller.scrollTop = scrollTop > 0 ? scrollTop : 0;
        this.scroller.scrollLeft = scrollLeft > 0 ? scrollLeft : 0;
        this.scroller.scrollWidth = (0, _dom).getScrollHeight(this.scroller.el);
        this.scroller.scrollHeight = (0, _dom).getScrollWidth(this.scroller.el);
        if (oldScroller.scrollLeft !== this.scroller.scrollLeft || oldScroller.scrollTop !== this.scroller.scrollTop) // We hebben een nieuwe scroll positie, dus we moeten de visible items updaten
        this.calculateVisibleItems();
    };
    _proto.onResize = function onResize() {
        this.checkRootOffset();
        this.lockBetweenScrollPos = {
            start: 0,
            end: 0
        };
        // Bereken hoeveel items we nodig hebben om de scroller te vullen
        this.initalNumToRender = this.config.initialItemsToRender !== undefined ? this.config.initialItemsToRender : Math.ceil(this.scrollerSize / this.config.estimatedItemSize);
        this.calculateVisibleItems();
    };
    _proto.onEndReached = function onEndReached() {
        if (this._onEndReachedRunning) return;
        if (this.config.onEndReached) {
            var _this = this;
            this._onEndReachedRunning = true;
            this.config.onEndReached().then(function() {
                _this._onEndReachedRunning = false;
                _this.calculateVisibleItems();
            }).catch(function() {
            // Negeren
            });
        }
    };
    _proto.setRenderData = function setRenderData(data) {
        var cacheKey = data.items.map(function(item) {
            return item.item.key + '-' + JSON.stringify(item.area);
        }).join(',');
        if (this.renderDataCache === cacheKey) return;
        this.renderDataCache = cacheKey;
        this.config.onRenderUpdate(data);
    };
    _proto.getCachedItemSize = function getCachedItemSize(item) {
        var layout = this.itemLayoutCache.get(item.key);
        if (!layout || _instanceof(layout, Promise)) return undefined;
        return this.isVertical ? layout.height : layout.width;
    };
    _proto.normalizeLayout = function normalizeLayout(layout1) {
        if (_instanceof(layout1, Promise)) return new Promise(function(resolve, reject) {
            layout1.then(function(layout) {
                resolve({
                    height: Math.ceil(layout.height),
                    width: Math.ceil(layout.width)
                });
            }).catch(function(err) {
                reject(err);
            });
        });
        return {
            height: Math.ceil(layout1.height),
            width: Math.ceil(layout1.width)
        };
    };
    _proto.getItemSize = function getItemSize(item, index) {
        if (!this.isMounted) return 0;
        var layout2 = this.itemLayoutCache.get(item.key);
        if (!layout2) layout2 = this.itemLayoutCache.set(item.key, this.config.getItemLayout(item, index));
        if (_instanceof(layout2, Promise)) {
            var _this = this;
            layout2.then(function(layout) {
                _this.itemLayoutCache.set(item.key, layout);
                _this.calculateVisibleItems();
            });
            return undefined;
        }
        return this.isVertical ? layout2.height : layout2.width;
    };
    _proto.setItemLayout = function setItemLayout(item, layout) {
        // Eerst normaliseren
        layout = this.normalizeLayout(layout);
        var oldLayout = this.itemLayoutCache.get(item.key);
        if (oldLayout) {
            if (!_instanceof(oldLayout, Promise)) {
                // Waarden zijn gelijk gebleven, skip maar
                if (oldLayout.height === layout.height && oldLayout.width === layout.width) return;
            }
        }
        this.itemLayoutCache.set(item.key, layout);
        // We moeten de visible items updaten, omdat de item size misschien gewijzigd is
        this.lockBetweenScrollPos = {
            start: 0,
            end: 0
        };
        this.calculateVisibleItems();
    };
    _proto.calculateVisibleItems = function calculateVisibleItems() {
        var reset = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        if (this.isLocked || !this.isMounted) return;
        this.lock();
        if (reset) this.itemLayoutCache.clear();
        var renderData = {
            spaceBefore: 0,
            sumItemSize: 0,
            items: [],
            indexesInViewport: []
        };
        var scrollPos = Math.max(0, this.scrollerPos - this.root.before);
        if (scrollPos > this.lockBetweenScrollPos.start && scrollPos < this.lockBetweenScrollPos.end) // We zitten nog steeds in de locked area, dus we hoeven niets te doen
        return this.unlock();
        var remainingWindowSize = Math.max(0, this.config.windowSize - 1);
        var windowSizeAfter = Math.max(0, Math.ceil(remainingWindowSize / 2));
        var windowSizeBefore = Math.max(0, remainingWindowSize - windowSizeAfter);
        if (this.items.length > 0) {
            var ref, ref1;
            var renderAbleArea = {
                start: scrollPos - windowSizeBefore * this.scrollerSize,
                end: scrollPos + this.scrollerSize + windowSizeAfter * this.scrollerSize
            };
            var viewPort = {
                start: scrollPos,
                end: scrollPos + this.scrollerSize
            };
            var offset = 0;
            for(var index = 0; index < this.items.length; index++){
                var item = this.items[index];
                var size = this.getItemSize(item, index);
                // Check if promise is resolved
                if (size === undefined) return this.unlock();
                var itemArea = {
                    start: offset,
                    end: offset + size,
                    size: size
                };
                offset += size;
                // Item hits renderAbleArea
                var hit = itemArea.end >= renderAbleArea.start && itemArea.start <= renderAbleArea.end;
                var inViewport = itemArea.end >= viewPort.start && itemArea.start <= viewPort.end;
                if (this.initalNumToRender && renderData.items.length > 0 && this.renderInitialItems) {
                    // Eerste zoveel items renderen we altijd met deze config, voorkomt zichtbare render waterval
                    var isInitalRender = index < this.initalNumToRender && index > renderData.items[0].index;
                    if (isInitalRender) hit = true;
                }
                if (!hit) {
                    if (renderData.items.length > 0) break;
                    if (this.initalNumToRender && index > this.initalNumToRender) // Voorbij de initalNumsToRender dus deze flag mag uit
                    // Als we terug scrollen moet normale logica weer werken
                    this.renderInitialItems = false;
                    continue;
                }
                renderData.items.push({
                    item: item,
                    area: itemArea,
                    index: index
                });
                if (index === this.items.length - 1) // We hebben het laatste item bereikt, dus we kunnen de onEndReached event triggeren
                this.onEndReached();
                if (inViewport) renderData.indexesInViewport.push(index);
            }
            renderData.spaceBefore = renderData.items.length > 0 ? renderData.items[0].area.start : offset;
            this.lockBetweenScrollPos = {
                start: ((ref = renderData.items[0]) === null || ref === void 0 ? void 0 : ref.area.start) + windowSizeBefore * this.scrollerSize,
                end: ((ref1 = renderData.items[renderData.items.length - 1]) === null || ref1 === void 0 ? void 0 : ref1.area.end) - windowSizeAfter * this.scrollerSize - this.scrollerSize
            };
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = this.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var item1 = _step.value;
                    // We halen alleen de size op van de items waarvan de size bekend is
                    // hierdoor geen renders
                    var size1 = this.getCachedItemSize(item1);
                    if (size1 === undefined) break;
                    renderData.sumItemSize += size1;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        this.setRenderData(renderData);
        this.unlock();
    };
    _proto.lock = function lock() {
        this._locks++;
    };
    _proto.unlock = function unlock() {
        if (this._locks > 0) this._locks--;
    };
    _proto.setItems = function setItems(data) {
        var _this = this;
        var missingKeys = false;
        var newKeys = data.map(function(item) {
            if (process.env.NODE_ENV === 'development' && typeof item.key !== "string") missingKeys = true;
            return item.key;
        });
        if (missingKeys) {
            console.error('Some items have an invalid key, this is not allowed and will cause issues. Expecting a string as key');
            return;
        }
        this.itemLayoutCache.cache.forEach(function(layout, key) {
            if (!newKeys.includes(key)) // Item is verwijderd
            _this.itemLayoutCache.delete(key);
        });
        this.items = data;
        this.calculateVisibleItems();
    };
    _createClass(Store, [
        {
            key: "isVertical",
            get: function get() {
                return this.config.direction === 'vertical';
            }
        },
        {
            key: "scrollerPos",
            get: function get() {
                var pos = this.isVertical ? this.scroller.scrollTop : this.scroller.scrollLeft;
                return pos;
            }
        },
        {
            key: "scrollerSize",
            get: function get() {
                var size = this.isVertical ? this.scroller.height : this.scroller.width;
                return size;
            }
        },
        {
            key: "isLocked",
            get: function get() {
                return this._locks > 0;
            }
        }
    ]);
    return Store;
}();
var _default = Store;
exports.default = _default;
